import { baseApi as api } from 'shared/api/baseApi';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		publicOffersRetrieve: build.query<PublicOffersRetrieveApiResponse, PublicOffersRetrieveApiArg>({
			query: (queryArg) => ({ url: `/api/public/offers/${queryArg}/` }),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PublicOffersRetrieveApiResponse = /** status 200  */ OfferDetailsRead;
export type PublicOffersRetrieveApiArg = string;
export type OfferDetails = {
	name: string;
	description: string;
	category: string;
	price: string;
	deadline?: string | null;
};
export type OfferOwner = {};
export type OfferOwnerRead = {
	id: string;
	username: string;
	email: string;
};
export type OfferAttachment = {};
export type OfferAttachmentRead = {
	id: string;
	file: string;
	created_at: string;
};
export type OfferDetailsRead = {
	id: string;
	name: string;
	description: string;
	category: string;
	status: string;
	type: string;
	price: string;
	deadline?: string | null;
	published_at: string;
	owner: OfferOwnerRead;
	attachments: OfferAttachmentRead[];
	created_at: string;
	updated_at: string;
};
